
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11508',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11508",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.214",
  "data-fetching-client": "static-1.9461",
  "foundations-components": "static-1.7490",
  "foundations-components-legacy": "static-1.515",
  "foundations-theming": "static-1.4192",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7788",
  "hub-http-shared-msw-handlers": "static-1.9439",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11206",
  "I18n": "static-7.1564",
  "jasmine-runner": "static-1.6254",
  "marketplace-storefront-base": "static-1.11568",
  "quartz": "static-1.6702",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16425",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2645",
  "reporting-testing-lib": "static-1.8379",
  "settings-ui-lib": "static-1.12303",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6695",
  "ui-addon-i18n": "static-1.10916",
  "ui-addon-react-router-dom": "static-1.9330",
  "unified-auth": "static-1.180",
  "unified-auth-core-lib": "static-1.461",
  "usage-tracker": "static-1.7115",
  "usage-tracker-core": "static-1.6965",
  "customer-data-property-utils": "static-1.7853",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15364",
  "marketplace-ui-common": "static-1.18890",
  "property-management-iframe": "static-1.12257",
  "quartz-config": "static-1.480",
  "quartz-core": "static-1.5921",
  "quartz-routing": "static-1.132",
  "quick-fetch": "static-1.3718",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4415",
  "ts-schema": "static-1.3887",
  "ui-universal-auth": "static-1.8666",
  "UIComponents": "static-3.8153",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3211",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2979",
  "quartz-webpack": "static-1.2926",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3759",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4617",
  "foundations-theming-specialty": "static-1.1908",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9210",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5157",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1139",
  "ui-fonts": "static-1.468",
  "ui-images": "static-2.1087",
  "bend-plugin-foundations-theming": "static-1.2675",
  "foundations-theming-base": "static-1.3177",
  "stylex": "static-1.27",
  "HeadJS": "static-2.706",
  "hs-test-utils-bend-plugin": "static-1.2899",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4111",
  "ai-components-ui-library": "static-1.8304",
  "ai-rendering-library": "static-1.9247",
  "chirp-fetch": "static-1.1666",
  "connections-embed-lib": "static-1.601",
  "copilot-toolkit": "static-1.10479",
  "laboratory-lib": "static-3.6945",
  "marketplace-embed": "static-1.21440",
  "marketplace-ui-details": "static-1.8786",
  "marketplace-ui-reviews": "static-1.18846",
  "marketplace-ui-tracking": "static-1.13061",
  "sanitize-text": "static-1.7922",
  "ui-addon-video-player": "static-1.8478",
  "usage-tracker-multi": "static-1.5529",
  "usage-tracker-session-replay": "static-1.4801",
  "wootric-nps": "static-1.6764",
  "apollo-link-hub-http": "static-2.4431",
  "immer": "static-1.33",
  "immerable": "static-1.3937",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2384",
  "reporting-data": "static-1.66446",
  "cssUtils": "static-1.726",
  "flux-actions": "static-1.306",
  "HubStyle": "static-2.11514",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9993",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10156",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7105",
  "icons": "static-2.620",
  "marketplace-ui-apps-core": "static-1.17423",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4305",
  "foundations-components-test-utils": "static-1.4973",
  "quartz-i18n": "static-1.377",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3514",
  "customer-data-objects": "static-1.7428",
  "property-translator": "static-1.5196",
  "frontend-preferences-client": "static-1.7706",
  "hs-promise-utils": "static-1.5374",
  "hubspot-apollo-client": "static-1.4662",
  "integrations-error-boundary-lib": "static-1.12779",
  "integrations-tracking-lib": "static-1.5367",
  "native-integrations-shared-strings": "static-1.7571",
  "reselect": "static-2.16",
  "sanitize": "static-1.4258",
  "superstore": "static-1.4554",
  "ui-shepherd-react": "static-3.9927",
  "ai-settings-ui-library": "static-1.7399",
  "hub-http-janus": "static-1.789",
  "hubspotter-http": "static-1.4461",
  "immutable-less": "static-1.4436",
  "marketplace-ui-client-types": "static-1.16297",
  "nav-meta": "static-1.28852",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10019",
  "ui-addon-upgrades": "static-9.17625",
  "inbound-db-properties-service-client": "static-1.3659",
  "property-management-common": "static-1.4544",
  "ui-addon-iframeable": "static-1.8824",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.377",
  "quartz-head": "static-1.367",
  "quartz-test": "static-1.377",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2926",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20237",
  "ContentUtils": "static-1.67575",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2267",
  "customer-data-filters-ui": "static-1.38844",
  "customer-data-objects-ui-components": "static-1.12787",
  "customer-data-reference-ui-components": "static-1.12924",
  "embedded-academy-lib": "static-1.13445",
  "ExportDialog": "static-6.10168",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40615",
  "reporting-snowflake": "static-1.55064",
  "reporting-ui-components": "static-2.63717",
  "reporting-visualizations": "static-1.58522",
  "ui-addon-teams": "static-1.21216",
  "magpie-lib": "static-1.5376",
  "magpie-types": "static-1.4836",
  "simple-logging-lib": "static-1.2833",
  "navigation-components": "static-1.17215",
  "ai-studio-lib": "static-1.10954",
  "developer-experience-shared-components": "static-1.10250",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7767",
  "ui-tool-access": "static-1.9926",
  "usage-based-billing-components-lib": "static-1.7956",
  "usage-tracker-anonymous": "static-1.5532",
  "usage-tracker-public": "static-1.6926",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3401",
  "persist-promise": "static-1.3489",
  "reference-resolvers": "static-1.7943",
  "ui-extensibility-client-types": "static-1.3729",
  "hubspot-apollo-cache": "static-1.121",
  "universal-page-editor-lib": "static-1.2780",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2143",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4853",
  "purchase-motions-components": "static-1.5458",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1332",
  "crm-component-utils": "static-1.38451",
  "crm-properties-common-lib": "static-1.5653",
  "framework-data-schema-resolvers": "static-1.6653",
  "reference-resolvers-lite": "static-1.7873",
  "navigation-messaging": "static-1.6542",
  "hubspotter-http-shared-msw-handlers": "static-1.9437",
  "cms-field-types": "static-1.4588",
  "content-icons-ui": "static-1.2148",
  "conversations-skeleton-state": "static-1.7031",
  "crm-message-bus": "static-1.42310",
  "customer-data-filters-ui-msw-helpers": "static-1.21278",
  "customer-data-ui-utilities": "static-1.9606",
  "FormUrlGenerator": "static-2.4513",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6558",
  "multi-account-reference-resolvers": "static-1.753",
  "onboarding-tours": "static-1.16231",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12989",
  "academy-common-lib": "static-1.12905",
  "content-assistance-lib": "static-1.7423",
  "dashboard-lib": "static-1.80562",
  "file-manager-components": "static-1.22836",
  "getting-started-shared-tasks": "static-1.17838",
  "hubspot-prosemirror": "static-1.17563",
  "hubspot-prosemirror-plugins": "static-1.17555",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19441",
  "share-with-third-party-component-lib": "static-1.8474",
  "ui-addon-draggable": "static-3.4549",
  "ui-asset-management-lib": "static-1.10684",
  "ui-business-units-lib": "static-1.8808",
  "user-context": "static-1.4878",
  "growth-payments-core": "static-1.24684",
  "reporting-plugins": "static-1.9957",
  "reporting-reports": "static-1.66124",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.508",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28822",
  "react-codemirror": "static-1.10409",
  "apps-service-types": "static-1.3662",
  "oauth-service-types": "static-1.4024",
  "onboarding-scopes": "static-1.6246",
  "onboarding-tours-client": "static-1.4445",
  "platform-infra-nav-components": "static-1.7476",
  "subscription-experience-data-types": "static-1.14563",
  "crm-record-cards-service-types": "static-1.3436",
  "location-customization-utils-lib": "static-1.8512",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2139",
  "purchase-motions-api": "static-1.5461",
  "signup-constants": "static-1.18350",
  "signup-ui-url-generator": "static-2.7850",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43475",
  "crm-actions": "static-1.6079",
  "crm-cards-data": "static-1.1173",
  "crm-cards-sdk": "static-1.42866",
  "customer-data-properties": "static-1.50755",
  "customer-data-properties-shared-msw-handlers": "static-1.8766",
  "customer-data-tracking": "static-1.6664",
  "conditional-properties-service-client": "static-1.3607",
  "crm-pipelines-api-client-types": "static-1.3948",
  "multi-currency-client-types": "static-1.3501",
  "external-options-client-types": "static-1.3968",
  "react-dnd-compat": "static-1.4404",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5133",
  "growth-onboarding-confetti": "static-1.2853",
  "growth-onboarding-next-action-utils": "static-1.1278",
  "onboarding-tours-utils": "static-1.297",
  "ui-shepherd-tracker": "static-1.7308",
  "academy-service-client": "static-1.3464",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27900",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8168",
  "video-components-external": "static-1.10513",
  "video-data-lib": "static-1.34171",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8352",
  "payment-link-components": "static-1.22898",
  "ui-addon-emoji-picker": "static-1.9671",
  "EmailSignatureEditor": "static-1.23872",
  "viral-links-lib": "static-1.6815",
  "data-token-picker": "static-1.16013",
  "FileManagerLib": "static-1.38476",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5027",
  "getting-started-shared-tasks-store": "static-1.16956",
  "campaign-roi-lib": "static-1.8224",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.173",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91157",
  "crm-links": "static-1.6039",
  "customer-data-sidebar": "static-2.45371",
  "enrichment-properties-lib": "static-1.14954",
  "crm-fe-perf": "static-1.22688",
  "calling-global-api": "static-1.63598",
  "calling-internal-common": "static-1.31073",
  "calling-lifecycle-internal": "static-1.64980",
  "calling-lifecycle-messages": "static-1.57274",
  "commerce-products-lib": "static-1.8814",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.458",
  "inbounddb-objects-service-types": "static-1.4033",
  "meetings-icalendar-utils-lib": "static-1.416",
  "object-builder-ui-client": "static-1.47914",
  "pipeline-validation-client-types": "static-1.3770",
  "property-value-citations": "static-1.1369",
  "pulse": "static-1.289",
  "smart-property-lib": "static-1.5836",
  "tiered-pricing": "static-1.802",
  "ui-addon-form-validation": "static-1.10777",
  "growth-onboarding-feedback-components": "static-1.6367",
  "content-media-composition-data-lib": "static-1.11388",
  "content-media-compositions": "static-2.15395",
  "media-bridge-lib": "static-1.18535",
  "commerce-tours-lib": "static-1.5690",
  "growth-onboarding-reliability": "static-1.4870",
  "sales-checkout-service-client": "static-1.3461",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21279",
  "sales-email-signature-service-client": "static-1.3628",
  "audio-components": "static-1.5587",
  "FileManagerCore": "static-1.38335",
  "FileManagerImages": "static-1.35987",
  "video-components": "static-1.12516",
  "crm_universal": "static-1.21631",
  "customer-data-email": "static-1.17640",
  "calling-error-reporting": "static-1.31079",
  "card-payment-highlight-lib": "static-1.36461",
  "card-subscription-highlight-lib": "static-1.38817",
  "commerce-billing-lib": "static-1.18457",
  "commerce-contract-lib": "static-1.11106",
  "customer-data-content": "static-1.26842",
  "invoices-highlight-card-lib": "static-1.53960",
  "orders-highlight-card-lib": "static-1.20829",
  "products-highlight-card-lib": "static-1.17098",
  "project-storage": "static-1.4515",
  "quotes-highlight-card-lib": "static-1.71108",
  "breeze-intelligence-kit": "static-1.5296",
  "crm-source-interpretation-lib": "static-1.5110",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9522",
  "policy-lib": "static-1.6565",
  "shared-worker-versioning": "static-1.10819",
  "calling-usage-tracker": "static-1.6321",
  "voice-sms-access-library": "static-1.198",
  "products-iframe-lib": "static-1.7269",
  "products-ui-components-shared-msw-handlers": "static-1.9821",
  "directed-graph": "static-1.720",
  "event-emitter": "static-1.730",
  "react-tinymce": "static-1.54574",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9585",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53700",
  "tinymce-plugins": "static-1.56814",
  "tinymce-themes": "static-1.55670",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4316",
  "video-embed": "static-1.35005",
  "social-insights-client-types": "static-1.21277",
  "sequences-lib": "static-1.7662",
  "ui-gdpr-components": "static-1.10130",
  "commerce-shared-components-lib": "static-1.17869",
  "commerce-subscription-lib": "static-1.36394",
  "commerce-tools-ui-lib": "static-1.9751",
  "utility-belt": "static-1.2325",
  "payments-enrollment-embed-lib": "static-1.21946",
  "products-ui-components": "static-1.39333",
  "quotes-client-types": "static-1.37196",
  "quotes-ui-lib": "static-1.79827",
  "SalesContentIndexUI": "static-3.8873",
  "accounting-integrations-ui-components": "static-1.6695",
  "invoices-ui-lib": "static-1.53976",
  "commerce-products-api": "static-1.1931",
  "SafeStorage": "static-1.4187",
  "invoices-iframe-lib": "static-1.56034",
  "quotes-modal-lib": "static-1.101784",
  "calling-orchestration-schema": "static-1.34975",
  "sales-views-client-types": "static-1.4075",
  "hub-http-contrib": "static-1.2828",
  "interframe": "static-3.4574",
  "tinymce-data": "static-1.39785",
  "ui-addon-sales-email": "static-1.4995",
  "layout-dnd-components": "static-1.12000",
  "layout-dnd-utils": "static-1.10975",
  "ui-brand-identity-lib": "static-1.13780",
  "NamespacedHubStyle": "static-2.8880",
  "outpost": "static-1.3988",
  "sequences-client-types-lib": "static-1.7519",
  "customer-data-associations": "static-1.7118",
  "framework-data-table": "static-2.11370",
  "customer-data-rte": "static-1.32405",
  "cv-backend-services": "static-1.1495",
  "growth-onboarding-empty-states": "static-1.5337",
  "InboxConnectUtils": "static-4.14180",
  "payments-post-enroll-local-storage-lib": "static-1.4895",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7103",
  "commerce-permissions": "static-1.535",
  "commerce-tax-lib": "static-1.294",
  "property-description-translator": "static-1.3642",
  "FireAlarmUi": "static-1.4312",
  "sales-templates-service-types-lib": "static-1.3978",
  "commerce-analytics-service-client": "static-1.3449",
  "totals-ui-components": "static-1.22957",
  "ContentData": "static-1.67650",
  "layout-data-lib": "static-1.9300",
  "deal-intel-decorators": "static-1.1203",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27673",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3621",
  "advanced-menus-core": "static-1.14787",
  "advanced-menus-lib": "static-1.11766",
  "ui-memberships-settings-lib": "static-1.33384",
  "deal-intel-utils": "static-1.1207",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14786",
  "simple-menus-lib": "static-1.16303"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11508",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.214",
  "data-fetching-client": "/data-fetching-client/static-1.9461",
  "foundations-components": "/foundations-components/static-1.7490",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.515",
  "foundations-theming": "/foundations-theming/static-1.4192",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7788",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9439",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11206",
  "I18n": "/I18n/static-7.1564",
  "jasmine-runner": "/jasmine-runner/static-1.6254",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11568",
  "quartz": "/quartz/static-1.6702",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16425",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2645",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8379",
  "settings-ui-lib": "/settings-ui-lib/static-1.12303",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6695",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10916",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9330",
  "unified-auth": "/unified-auth/static-1.180",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.461",
  "usage-tracker": "/usage-tracker/static-1.7115",
  "usage-tracker-core": "/usage-tracker-core/static-1.6965",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7853",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15364",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18890",
  "property-management-iframe": "/property-management-iframe/static-1.12257",
  "quartz-config": "/quartz-config/static-1.480",
  "quartz-core": "/quartz-core/static-1.5921",
  "quartz-routing": "/quartz-routing/static-1.132",
  "quick-fetch": "/quick-fetch/static-1.3718",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4415",
  "ts-schema": "/ts-schema/static-1.3887",
  "ui-universal-auth": "/ui-universal-auth/static-1.8666",
  "UIComponents": "/UIComponents/static-3.8153",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2979",
  "quartz-webpack": "/quartz-webpack/static-1.2926",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3759",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4617",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1908",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9210",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5157",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1139",
  "ui-fonts": "/ui-fonts/static-1.468",
  "ui-images": "/ui-images/static-2.1087",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2675",
  "foundations-theming-base": "/foundations-theming-base/static-1.3177",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.706",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2899",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4111",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8304",
  "ai-rendering-library": "/ai-rendering-library/static-1.9247",
  "chirp-fetch": "/chirp-fetch/static-1.1666",
  "connections-embed-lib": "/connections-embed-lib/static-1.601",
  "copilot-toolkit": "/copilot-toolkit/static-1.10479",
  "laboratory-lib": "/laboratory-lib/static-3.6945",
  "marketplace-embed": "/marketplace-embed/static-1.21440",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8786",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18846",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13061",
  "sanitize-text": "/sanitize-text/static-1.7922",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8478",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5529",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4801",
  "wootric-nps": "/wootric-nps/static-1.6764",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4431",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3937",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2384",
  "reporting-data": "/reporting-data/static-1.66446",
  "cssUtils": "/cssUtils/static-1.726",
  "flux-actions": "/flux-actions/static-1.306",
  "HubStyle": "/HubStyle/static-2.11514",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9993",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10156",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7105",
  "icons": "/icons/static-2.620",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17423",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4305",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4973",
  "quartz-i18n": "/quartz-i18n/static-1.377",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3514",
  "customer-data-objects": "/customer-data-objects/static-1.7428",
  "property-translator": "/property-translator/static-1.5196",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7706",
  "hs-promise-utils": "/hs-promise-utils/static-1.5374",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4662",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12779",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5367",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7571",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4258",
  "superstore": "/superstore/static-1.4554",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9927",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7399",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "hubspotter-http": "/hubspotter-http/static-1.4461",
  "immutable-less": "/immutable-less/static-1.4436",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16297",
  "nav-meta": "/nav-meta/static-1.28852",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10019",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17625",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3659",
  "property-management-common": "/property-management-common/static-1.4544",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8824",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.377",
  "quartz-head": "/quartz-head/static-1.367",
  "quartz-test": "/quartz-test/static-1.377",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20237",
  "ContentUtils": "/ContentUtils/static-1.67575",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2267",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38844",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12787",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12924",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13445",
  "ExportDialog": "/ExportDialog/static-6.10168",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40615",
  "reporting-snowflake": "/reporting-snowflake/static-1.55064",
  "reporting-ui-components": "/reporting-ui-components/static-2.63717",
  "reporting-visualizations": "/reporting-visualizations/static-1.58522",
  "ui-addon-teams": "/ui-addon-teams/static-1.21216",
  "magpie-lib": "/magpie-lib/static-1.5376",
  "magpie-types": "/magpie-types/static-1.4836",
  "simple-logging-lib": "/simple-logging-lib/static-1.2833",
  "navigation-components": "/navigation-components/static-1.17215",
  "ai-studio-lib": "/ai-studio-lib/static-1.10954",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10250",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7767",
  "ui-tool-access": "/ui-tool-access/static-1.9926",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7956",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5532",
  "usage-tracker-public": "/usage-tracker-public/static-1.6926",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3401",
  "persist-promise": "/persist-promise/static-1.3489",
  "reference-resolvers": "/reference-resolvers/static-1.7943",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3729",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.121",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2780",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2143",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4853",
  "purchase-motions-components": "/purchase-motions-components/static-1.5458",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1332",
  "crm-component-utils": "/crm-component-utils/static-1.38451",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5653",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6653",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7873",
  "navigation-messaging": "/navigation-messaging/static-1.6542",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9437",
  "cms-field-types": "/cms-field-types/static-1.4588",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7031",
  "crm-message-bus": "/crm-message-bus/static-1.42310",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21278",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9606",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4513",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6558",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.753",
  "onboarding-tours": "/onboarding-tours/static-1.16231",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12989",
  "academy-common-lib": "/academy-common-lib/static-1.12905",
  "content-assistance-lib": "/content-assistance-lib/static-1.7423",
  "dashboard-lib": "/dashboard-lib/static-1.80562",
  "file-manager-components": "/file-manager-components/static-1.22836",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17838",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17563",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17555",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19441",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8474",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4549",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10684",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8808",
  "user-context": "/user-context/static-1.4878",
  "growth-payments-core": "/growth-payments-core/static-1.24684",
  "reporting-plugins": "/reporting-plugins/static-1.9957",
  "reporting-reports": "/reporting-reports/static-1.66124",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.508",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28822",
  "react-codemirror": "/react-codemirror/static-1.10409",
  "apps-service-types": "/apps-service-types/static-1.3662",
  "oauth-service-types": "/oauth-service-types/static-1.4024",
  "onboarding-scopes": "/onboarding-scopes/static-1.6246",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4445",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7476",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14563",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3436",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8512",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2139",
  "purchase-motions-api": "/purchase-motions-api/static-1.5461",
  "signup-constants": "/signup-constants/static-1.18350",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7850",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43475",
  "crm-actions": "/crm-actions/static-1.6079",
  "crm-cards-data": "/crm-cards-data/static-1.1173",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42866",
  "customer-data-properties": "/customer-data-properties/static-1.50755",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8766",
  "customer-data-tracking": "/customer-data-tracking/static-1.6664",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3607",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3948",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3501",
  "external-options-client-types": "/external-options-client-types/static-1.3968",
  "react-dnd-compat": "/react-dnd-compat/static-1.4404",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5133",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2853",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1278",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.297",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7308",
  "academy-service-client": "/academy-service-client/static-1.3464",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27900",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8168",
  "video-components-external": "/video-components-external/static-1.10513",
  "video-data-lib": "/video-data-lib/static-1.34171",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8352",
  "payment-link-components": "/payment-link-components/static-1.22898",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9671",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23872",
  "viral-links-lib": "/viral-links-lib/static-1.6815",
  "data-token-picker": "/data-token-picker/static-1.16013",
  "FileManagerLib": "/FileManagerLib/static-1.38476",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5027",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16956",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8224",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.173",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91157",
  "crm-links": "/crm-links/static-1.6039",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45371",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14954",
  "crm-fe-perf": "/crm-fe-perf/static-1.22688",
  "calling-global-api": "/calling-global-api/static-1.63598",
  "calling-internal-common": "/calling-internal-common/static-1.31073",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64980",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57274",
  "commerce-products-lib": "/commerce-products-lib/static-1.8814",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.458",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4033",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.416",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47914",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3770",
  "property-value-citations": "/property-value-citations/static-1.1369",
  "pulse": "/pulse/static-1.289",
  "smart-property-lib": "/smart-property-lib/static-1.5836",
  "tiered-pricing": "/tiered-pricing/static-1.802",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10777",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6367",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11388",
  "content-media-compositions": "/content-media-compositions/static-2.15395",
  "media-bridge-lib": "/media-bridge-lib/static-1.18535",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5690",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4870",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3461",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21279",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3628",
  "audio-components": "/audio-components/static-1.5587",
  "FileManagerCore": "/FileManagerCore/static-1.38335",
  "FileManagerImages": "/FileManagerImages/static-1.35987",
  "video-components": "/video-components/static-1.12516",
  "crm_universal": "/crm_universal/static-1.21631",
  "customer-data-email": "/customer-data-email/static-1.17640",
  "calling-error-reporting": "/calling-error-reporting/static-1.31079",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36461",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38817",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18457",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11106",
  "customer-data-content": "/customer-data-content/static-1.26842",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53960",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20829",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17098",
  "project-storage": "/project-storage/static-1.4515",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71108",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5296",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5110",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9522",
  "policy-lib": "/policy-lib/static-1.6565",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10819",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6321",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.198",
  "products-iframe-lib": "/products-iframe-lib/static-1.7269",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9821",
  "directed-graph": "/directed-graph/static-1.720",
  "event-emitter": "/event-emitter/static-1.730",
  "react-tinymce": "/react-tinymce/static-1.54574",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9585",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53700",
  "tinymce-plugins": "/tinymce-plugins/static-1.56814",
  "tinymce-themes": "/tinymce-themes/static-1.55670",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4316",
  "video-embed": "/video-embed/static-1.35005",
  "social-insights-client-types": "/social-insights-client-types/static-1.21277",
  "sequences-lib": "/sequences-lib/static-1.7662",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10130",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17869",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36394",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9751",
  "utility-belt": "/utility-belt/static-1.2325",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21946",
  "products-ui-components": "/products-ui-components/static-1.39333",
  "quotes-client-types": "/quotes-client-types/static-1.37196",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79827",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8873",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6695",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53976",
  "commerce-products-api": "/commerce-products-api/static-1.1931",
  "SafeStorage": "/SafeStorage/static-1.4187",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56034",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101784",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34975",
  "sales-views-client-types": "/sales-views-client-types/static-1.4075",
  "hub-http-contrib": "/hub-http-contrib/static-1.2828",
  "interframe": "/interframe/static-3.4574",
  "tinymce-data": "/tinymce-data/static-1.39785",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4995",
  "layout-dnd-components": "/layout-dnd-components/static-1.12000",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10975",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13780",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8880",
  "outpost": "/outpost/static-1.3988",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7519",
  "customer-data-associations": "/customer-data-associations/static-1.7118",
  "framework-data-table": "/framework-data-table/static-2.11370",
  "customer-data-rte": "/customer-data-rte/static-1.32405",
  "cv-backend-services": "/cv-backend-services/static-1.1495",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5337",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14180",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4895",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7103",
  "commerce-permissions": "/commerce-permissions/static-1.535",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.294",
  "property-description-translator": "/property-description-translator/static-1.3642",
  "FireAlarmUi": "/FireAlarmUi/static-1.4312",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3978",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3449",
  "totals-ui-components": "/totals-ui-components/static-1.22957",
  "ContentData": "/ContentData/static-1.67650",
  "layout-data-lib": "/layout-data-lib/static-1.9300",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1203",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27673",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3621",
  "advanced-menus-core": "/advanced-menus-core/static-1.14787",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11766",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33384",
  "deal-intel-utils": "/deal-intel-utils/static-1.1207",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14786",
  "simple-menus-lib": "/simple-menus-lib/static-1.16303"
}
};
